import React, { useEffect, useState } from 'react';
import Logo from '../../../assets/dashboard/logo.png';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';

// Mock service calls (replace with real ones)
import { getMyPolicyById, addPolicy, updatePolicy, getAllStaff, updateSales, addSales, getMySalesById } from '../../../services/Trainer/trainer';

const StaffPerformanceFormPage = ({ onSubmit, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    staff: '',
    productSold: '',
    membershipSold: '',
    rebooked: '',
  });

  // const staffOptions = [
  //   { id: '681f96976670b35b117ca563', name: 'John Doe' },
  //   { id: '681f96976670b35b117ca999', name: 'Jane Smith' },
  //   { id: '681f96976670b35b117ca111', name: 'Alice Brown' },
  // ];
const [allStaffData, setAllStaffData] = useState(null);

  const fetchStaffData = async () => {
    const data = await getAllStaff();
    if (data) {
      console.log("Staff data >>>", data);
      const staffOptions = data.staffs.map(item => ({id: item._id, name: item?.fullName}));
      setAllStaffData(staffOptions);
    }
  };

  useEffect(() => {
    fetchStaffData();
  }, []);
  console.log("allStaffDataallStaffData",allStaffData)

  const validationSchema = Yup.object({
    staff: Yup.string().required('Staff is required'),
    productSold: Yup.number().min(0).required('Product Sold is required'),
    membershipSold: Yup.number().min(0).required('Membership Sold is required'),
    rebooked: Yup.number()
      .min(0, 'Rebooked % must be at least 0')
      .max(100, 'Rebooked % cannot exceed 100')
      .required('Rebooked % is required'),
  });

  const fetchData = async () => {
    const response = await getMySalesById(id); // Update to actual API if needed
    if (response?.success) {
      const data = response.data;
      console.log("dasgasdg",data)
      setInitialValues({
        staff:data?.staff?._id || '',
        productSold: data.productSold || '',
        membershipSold: data.membershipSold || '',
        rebooked: data.rebooked || '',
      });
    }
  };

  useEffect(() => {
    if (id) fetchData();
  }, []);

  const handleSubmit = async (values) => {
    const payload = {
      staff: values.staff,
      productSold: values.productSold,
      membershipSold: values.membershipSold,
      rebooked: values.rebooked,
    };

    setLoading(true);
    try {
      const result = id ? await updateSales(payload, id) : await addSales(payload);
      if (result?.success) {
        toast.success(result.message);
        navigate(-1);
      } else {
        toast.error(result.message || 'Something went wrong');
      }
    } catch (err) {
      console.error('Submission error:', err);
      toast.error('Failed to submit data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row justify-content-center my-5">
      <div className="card shadow col-lg-8">
        <div className="d-flex align-items-center justify-content-center mt-4">
          <div className="text-center mb-4">
            <img src={Logo} alt="Logo" width={100} />
          </div>
        </div>
        <h2 className="text-center fs-4 fw-bold mb-4 text-color">{id ? 'Edit' : 'Enter'} Sales Data</h2>

        <div className="card-body">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values }) => (
              <Form className="mb-4 px-4">
                {/* Staff Dropdown */}
                <div className="form-group mb-4">
                  <Field as="select" name="staff" className="custom-input">
                    <option value="">Select Staff</option>
                    {allStaffData && allStaffData.map((staff) => (
                      <option key={staff.id} value={staff.id}>
                        {staff.name}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage name="staff" component="div" className="error-text" />
                </div>

                {/* Product Sold */}
                <div className="form-group mb-4">
                  <Field
                    name="productSold"
                    type="text"
                    placeholder="Product Sold"
                    className="custom-input"
                  />
                  <ErrorMessage name="productSold" component="div" className="error-text" />
                </div>

                {/* Membership Sold */}
                <div className="form-group mb-4">
                  <Field
                    name="membershipSold"
                    type="text"
                    placeholder="Membership Sold"
                    className="custom-input"
                  />
                  <ErrorMessage name="membershipSold" component="div" className="error-text" />
                </div>

                {/* Rebooked Percentage */}
                <div className="form-group mb-4">
                  <Field
                    name="rebooked"
                    type="text"
                    placeholder="Rebooked %"
                    className="custom-input"
                  />
                  <ErrorMessage name="rebooked" component="div" className="error-text" />
                </div>

                <button type="submit" className="text-white w-100 py-2 submit-btn" disabled={loading}>
                  {loading ? 'Loading...' : id ? 'Update' : 'Confirm'}
                </button>

                {onCancel && (
                  <div className="mt-2">
                    <button
                      type="button"
                      className="btn btn-outline-secondary w-100 py-2"
                      onClick={onCancel}
                      disabled={loading}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default StaffPerformanceFormPage;
